import { useQuery } from 'react-query';
import { useTripDesignerConfig } from '../config/TripDesignerConfigProvider';
import type { FilterItem } from '../logic/tripFilterOptions';

const STALE = 5 * 60 * 1000;

function useList(key: string, fetch: () => Promise<{ data: unknown }>) {
  const { data, isLoading } = useQuery(['tripFilter', key], fetch, {
    staleTime: STALE,
  });
  return {
    items: ((data as any)?.data ?? []) as FilterItem[],
    isLoading,
  };
}

// The lists the filter bar picks from.
export function useTripFilterOptions() {
  const { api } = useTripDesignerConfig();

  return {
    themes: useList('themes', api.getThemes),
    segments: useList('segments', api.getSegments),
    categories: useList('categories', api.getCategories),
    kinds: useList('kinds', api.getKinds),
    styles: useList('styles', () => api.getStyles()),
    sustainableLevels: useList('sustainableLevels', api.getSustainableLevels),
  };
}

// The currency of the TO <-> DMC experience connection, or undefined.
export function useTripConnectionCurrency(
  organizationId: unknown,
  dmcId: unknown,
) {
  const { api } = useTripDesignerConfig();
  const { data } = useQuery(
    ['tripFilter', 'connectionCurrency', organizationId, dmcId],
    () =>
      api.getOrganizationByToDmc({
        toOrganizationId: parseInt(String(organizationId)),
        dmcOrganizationId: dmcId,
        kind: 'experience',
      }),
    { enabled: !!organizationId, staleTime: STALE },
  );
  // KD-3873: one connection row, not a list.
  return (data as any)?.data?.currency as string | undefined;
}
